export default [
  {
    code: 'id',
    name: 'id',
    type: 'id',
    required: false,
  },
  {
    code: 'goods',
    name: 'goods',
    type: 'select',
    dictionary: 'goods',
    itemValue: 'id',
    itemText: 'shortName',
    required: true,
  },
  {
    code: 'temperature',
    name: 'temperature',
    type: 'input',
    isNumber: true,
    required: true,
  },
  {
    code: 'density',
    name: 'density',
    type: 'input',
    isNumber: true,
    required: true,
  },
]
